const VERSION = { APP: 16, CODE: 16, NAME: "0.26", API: 1 };

export { VERSION };
